/** Local security default, separate from clinical thresholds; shared by warm and cold offline views. */
export const OFFLINE_IDLE_LOCK_MS = 15 * 60_000;
export function bindOfflineIdleLock(onLock: () => void, options: { activityTarget?: EventTarget; visibilityTarget?: EventTarget; idleMs?: number; now?: () => number } = {}) {
  const activityTarget = options.activityTarget ?? window;
  const visibilityTarget = options.visibilityTarget ?? document;
  const idleMs = options.idleMs ?? OFFLINE_IDLE_LOCK_MS;
  const now = options.now ?? Date.now;
  let lastActivity = now(); let locked = false;
  const check = () => { if (!locked && now() - lastActivity >= idleMs) { locked = true; onLock(); } };
  const activity = () => { check(); if (!locked) lastActivity = now(); };
  const timer = setInterval(check, Math.min(30000, idleMs));
  activityTarget.addEventListener('pointerdown', activity); activityTarget.addEventListener('keydown', activity);
  visibilityTarget.addEventListener('visibilitychange', check);
  return () => { clearInterval(timer); activityTarget.removeEventListener('pointerdown', activity); activityTarget.removeEventListener('keydown', activity); visibilityTarget.removeEventListener('visibilitychange', check); };
}
